import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateReferenceSurveyComponent } from './create-reference-survey.component';
import { FormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BannerModule, ButtonModule, TooltipModule as xrefTooltipModule } from '@xref/xref-lib';
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { OptInQuestionModule } from "../opt-in-question/opt-in-question.module";
import { CharacterLimitModule } from "../character-limit/character-limit.module";
import { NoteToCandidateAndRefereeModule } from '../note-to-candidate-and-referee/note-to-candidate-and-referee.module';
import {LoaderModule} from "../loader/loader.module";



@NgModule({
  declarations: [CreateReferenceSurveyComponent],
  imports: [
    CommonModule,
    FormsModule,
    BannerModule,
    AlertModule,
    OptInQuestionModule,
    TooltipModule.forRoot(),
    CharacterLimitModule,
    TooltipEllipsifyModule,
    xrefTooltipModule,
    NoteToCandidateAndRefereeModule,
    LoaderModule,
    ButtonModule
  ]
})
export class CreateReferenceSurveyModule { }
